"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortFunctionForArrayOfWaypoints = exports["default"] = exports.Monitoring = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDatetimePicker = require("nicbase-datetime-picker");

var _nicbaseDualList = require("nicbase-dual-list");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

var _constants = require("../constants");

var _route = _interopRequireDefault(require("./route"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var sortFunctionForArrayOfWaypoints = function sortFunctionForArrayOfWaypoints(waypoint1, waypoint2) {
  if (waypoint1.type === _constants.WAYPOINT_TYPES.START || waypoint2.type === _constants.WAYPOINT_TYPES.END) {
    return -1;
  }

  if (waypoint1.type === _constants.WAYPOINT_TYPES.END || waypoint2.type === _constants.WAYPOINT_TYPES.START) {
    return 1;
  }

  return 0;
}; // eslint-disable-next-line react/prop-types


exports.sortFunctionForArrayOfWaypoints = sortFunctionForArrayOfWaypoints;

var IconAnimation = function IconAnimation(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      toggle = _useState2[1];

  var spring = (0, _reactSpring.useSpring)({
    y: state ? 10 : 0,
    config: {
      duration: 500
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    onClick: function onClick() {
      toggle(!state);
    },
    className: "fill-primary cursor-pointer",
    style: {
      transform: spring.y.to({
        range: [0, 2.5, 5, 7.5, 10],
        output: [10, 7.5, 5, 7.5, 10]
      }).to(function (y) {
        return "translateY(-".concat(y, "px)");
      })
    }
  }, children);
};

var emailSchema = (0, _yup.string)().email();
var phoneSchema = (0, _yup.number)().min(1);

var determineIfIndividualNotificationsIsActive = function determineIfIndividualNotificationsIsActive(areDelayedAlarmsEnabled, isEtaMonitoringEnabled, areAlarmsEnabled, emailRecipients, smsRecipients) {
  var areNotificationsIndividual = emailRecipients.some(function (recipient) {
    return areAlarmsEnabled && !recipient.assignedAlarms || isEtaMonitoringEnabled && !recipient.etaAlarms || areDelayedAlarmsEnabled && !recipient.delayedStartEndAlarms;
  });
  areNotificationsIndividual = areNotificationsIndividual || smsRecipients.some(function (recipient) {
    return areAlarmsEnabled && !recipient.assignedAlarms || isEtaMonitoringEnabled && !recipient.etaAlarms || areDelayedAlarmsEnabled && !recipient.delayedStartEndAlarms;
  });
  return areNotificationsIndividual;
};

var Monitoring = function Monitoring(_ref2) {
  var _tour$route;

  var tour = _ref2.tour,
      tourRoute = _ref2.tourRoute,
      alarms = _ref2.alarms,
      onUpdate = _ref2.onUpdate,
      setTourRoute = _ref2.setTourRoute;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useUser = (0, _nicbaseReducers.useUser)(),
      email = _useUser.email,
      locale = _useUser.locale,
      timezone = _useUser.timezone;

  var emailRecipients = tour.emailRecipients,
      smsRecipients = tour.smsRecipients,
      startStopAlarmsEnabled = tour.startStopAlarmsEnabled,
      etaAlarmsEnabled = tour.etaAlarmsEnabled,
      wayPoints = tour.wayPoints,
      delayedStartLimitAlarm = tour.delayedStartLimitAlarm,
      delayedEndLimitAlarm = tour.delayedEndLimitAlarm;
  var isStartStopAlarmsEnabled = startStopAlarmsEnabled === true;
  var areAlarmsEnabled = tour.alarms.length > 0;

  var _useState3 = (0, _react.useState)(delayedStartLimitAlarm !== null || delayedEndLimitAlarm !== null),
      _useState4 = _slicedToArray(_useState3, 2),
      areDelayedAlarmsEnabled = _useState4[0],
      setAreDelayedAlarmsEnabled = _useState4[1];

  var _useState5 = (0, _react.useState)(determineIfIndividualNotificationsIsActive(areDelayedAlarmsEnabled, etaAlarmsEnabled, areAlarmsEnabled, emailRecipients, smsRecipients)),
      _useState6 = _slicedToArray(_useState5, 2),
      selectIndividualNotifications = _useState6[0],
      setSelectIndividualNotifications = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      mailAddress = _useState8[0],
      setMailAddress = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      phoneNumber = _useState10[0],
      setPhoneNumber = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      mailError = _useState12[0],
      setMailError = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      phoneError = _useState14[0],
      setPhoneError = _useState14[1];

  var _useState15 = (0, _react.useState)(!!((_tour$route = tour.route) !== null && _tour$route !== void 0 && _tour$route.id)),
      _useState16 = _slicedToArray(_useState15, 2),
      isRouteEnabled = _useState16[0],
      setIsRouteEnabled = _useState16[1];

  var onEtaProviderSelectionChange = function onEtaProviderSelectionChange(isEtaMonitoringEnabled) {
    var mappedWaypoints = wayPoints.map(function (wayPoint) {
      return _objectSpread(_objectSpread({}, wayPoint), {
        earlyTolerance: 30,
        lateTolerance: 30
      });
    });
    mappedWaypoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: mappedWaypoints
    });
    onUpdate({
      etaAlarmsEnabled: isEtaMonitoringEnabled
    });
    onUpdate({
      etaProvider: isEtaMonitoringEnabled ? _constants.ETA_PROVIDERS.PTV : _constants.ETA_PROVIDERS.NOTHING
    });
  };

  var onEarlyToleranceChange = function onEarlyToleranceChange(newTolerance) {
    var parsedTolerance = parseInt(newTolerance.replace(/\D*/, ''), 10) || 0;
    var mappedWaypoints = wayPoints.map(function (wayPoint) {
      return _objectSpread(_objectSpread({}, wayPoint), {
        earlyTolerance: parsedTolerance
      });
    });
    mappedWaypoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: mappedWaypoints
    });
  };

  var onLateToleranceChange = function onLateToleranceChange(newTolerance) {
    var parsedTolerance = parseInt(newTolerance.replace(/\D*/, ''), 10) || 0;
    var mappedWaypoints = wayPoints.map(function (wayPoint) {
      return _objectSpread(_objectSpread({}, wayPoint), {
        lateTolerance: parsedTolerance
      });
    });
    mappedWaypoints.sort(sortFunctionForArrayOfWaypoints);
    onUpdate({
      wayPoints: mappedWaypoints
    });
  };

  var onEmailAlarmChanged = function onEmailAlarmChanged() {
    var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var alarmProperty = arguments.length > 1 ? arguments[1] : undefined;
    var newValue = arguments.length > 2 ? arguments[2] : undefined;
    var updatedEmailRecipients = emailRecipients.map(function (rec) {
      if (recipients.includes(rec)) {
        return _objectSpread(_objectSpread({}, rec), _defineProperty({}, alarmProperty, newValue));
      }

      return rec;
    });
    onUpdate({
      emailRecipients: updatedEmailRecipients
    });
  };

  var onPhoneAlarmChanged = function onPhoneAlarmChanged() {
    var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var alarmProperty = arguments.length > 1 ? arguments[1] : undefined;
    var newValue = arguments.length > 2 ? arguments[2] : undefined;
    var updatedPhoneRecipients = smsRecipients.map(function (rec) {
      if (recipients.includes(rec)) {
        return _objectSpread(_objectSpread({}, rec), _defineProperty({}, alarmProperty, newValue));
      }

      return rec;
    });
    onUpdate({
      smsRecipients: updatedPhoneRecipients
    });
  };

  var _useState17 = (0, _react.useState)({
    routeAlarms: false,
    assignedAlarms: false,
    etaAlarms: false,
    startStopAlarms: false
  }),
      _useState18 = _slicedToArray(_useState17, 2),
      allEmailAlarmSelected = _useState18[0],
      setAllEmailAlarmSelected = _useState18[1];

  var _useState19 = (0, _react.useState)({
    routeAlarms: true,
    assignedAlarms: true,
    etaAlarms: true,
    startStopAlarms: true
  }),
      _useState20 = _slicedToArray(_useState19, 2),
      mailAlarmSelected = _useState20[0],
      setMailAlarmSelected = _useState20[1];

  var onNewEmailRecipient = function onNewEmailRecipient() {
    try {
      if (emailSchema.validateSync(mailAddress)) {
        var newEmailRecipients = emailRecipients.slice(0);
        newEmailRecipients.push(_objectSpread(_objectSpread({}, mailAlarmSelected), {}, {
          recipient: mailAddress
        }));
        onUpdate({
          emailRecipients: newEmailRecipients
        });
        setMailAddress('');
        setMailError(false);
      }
    } catch (e) {
      setMailError(true);
    }
  };

  var onAllEmailAlarmChanged = function onAllEmailAlarmChanged(condition, type) {
    setAllEmailAlarmSelected(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, !prev[type]));
    });
    setMailAlarmSelected(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, allEmailAlarmSelected[type]));
    });
    var updatedEmailRecipients = emailRecipients.map(function (rec) {
      return _objectSpread(_objectSpread({}, rec), _defineProperty({}, type, condition));
    });
    onUpdate({
      emailRecipients: updatedEmailRecipients
    });
  };

  var onDeleteEmailRecipient = function onDeleteEmailRecipient(name) {
    onUpdate({
      emailRecipients: emailRecipients.filter(function (recipient) {
        return recipient.recipient !== name;
      })
    });
  };

  var _useState21 = (0, _react.useState)({
    routeAlarms: false,
    assignedAlarms: false,
    etaAlarms: false,
    startStopAlarms: false
  }),
      _useState22 = _slicedToArray(_useState21, 2),
      allPhoneAlarmSelected = _useState22[0],
      setAllPhoneAlarmSelected = _useState22[1];

  var _useState23 = (0, _react.useState)({
    routeAlarms: true,
    assignedAlarms: true,
    etaAlarms: true,
    startStopAlarms: true
  }),
      _useState24 = _slicedToArray(_useState23, 2),
      phoneAlarmSelected = _useState24[0],
      setPhoneAlarmSelected = _useState24[1];

  var onAllPhoneAlarmChanged = function onAllPhoneAlarmChanged(condition, type) {
    setAllPhoneAlarmSelected(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, !prev[type]));
    });
    setPhoneAlarmSelected(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, allPhoneAlarmSelected[type]));
    });
    var updatedPhoneRecipients = smsRecipients.map(function (rec) {
      return _objectSpread(_objectSpread({}, rec), _defineProperty({}, type, condition));
    });
    onUpdate({
      smsRecipients: updatedPhoneRecipients
    });
  };

  var onPhoneNumberChanged = function onPhoneNumberChanged(phoneInput) {
    var cleanedRecipient = phoneInput.replace(/[^0-9+]/g, '');
    setPhoneNumber(cleanedRecipient);
  };

  var onNewPhoneRecipient = function onNewPhoneRecipient() {
    try {
      if (phoneSchema.validateSync(phoneNumber)) {
        var newPhoneRecipients = smsRecipients.slice(0);
        newPhoneRecipients.push(_objectSpread(_objectSpread({}, phoneAlarmSelected), {}, {
          recipient: phoneNumber
        }));
        onUpdate({
          smsRecipients: newPhoneRecipients
        });
        setPhoneNumber('');
        setPhoneError(false);
      }
    } catch (e) {
      setPhoneError(true);
    }
  };

  var onDeletePhoneRecipient = function onDeletePhoneRecipient(name) {
    onUpdate({
      smsRecipients: smsRecipients.filter(function (recipient) {
        return recipient.recipient !== name;
      })
    });
  };

  var onDelayedStartEndAlarms = function onDelayedStartEndAlarms(value) {
    setAreDelayedAlarmsEnabled(function (prev) {
      return !prev;
    });

    if (!value) {
      onUpdate({
        delayedStartLimitAlarm: null
      });
      onUpdate({
        delayedEndLimitAlarm: null
      });
    }

    onUpdate({
      emailRecipients: emailRecipients.map(function (recipient) {
        return _objectSpread(_objectSpread({}, recipient), {}, {
          delayedStartEndAlarms: value
        });
      })
    });
  };

  var onDelayedStartLimitAlarm = function onDelayedStartLimitAlarm(date) {
    onUpdate({
      delayedStartLimitAlarm: date ? date.toISOString() : null
    });
  };

  var onDelayedEndLimitAlarm = function onDelayedEndLimitAlarm(date) {
    onUpdate({
      delayedEndLimitAlarm: date ? date.toISOString() : null
    });
  };

  var earlyTolerance = wayPoints[0] && wayPoints[0].earlyTolerance;
  var lateTolerance = wayPoints[0] && wayPoints[0].lateTolerance;
  var endWaypointIndex = wayPoints.findIndex(function (wayPoint) {
    return wayPoint.type === _constants.WAYPOINT_TYPES.END;
  });
  var isSelectIndividualNotificationsToggleDisabled = !(isRouteEnabled || isStartStopAlarmsEnabled || etaAlarmsEnabled || areAlarmsEnabled || areDelayedAlarmsEnabled);
  var forms = (0, _react.useMemo)(function () {
    return [{
      name: 'routeAlarms',
      Icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.RouteDifference, null),
      enabled: isRouteEnabled
    }, {
      name: 'startStopAlarms',
      Icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.StartStopAlarmsEnabled, null),
      enabled: isStartStopAlarmsEnabled
    }, {
      name: 'delayedStartEndAlarms',
      Icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DelayNotificationAlarm, null),
      enabled: areDelayedAlarmsEnabled
    }, {
      name: 'etaAlarms',
      Icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ETA, null),
      enabled: etaAlarmsEnabled
    }, {
      name: 'assignedAlarms',
      Icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Alarms, null),
      enabled: areAlarmsEnabled
    }];
  }, [areAlarmsEnabled, areDelayedAlarmsEnabled, etaAlarmsEnabled, isRouteEnabled, isStartStopAlarmsEnabled]);
  var report = tour.report || {};
  var _report$recipients = report.recipients,
      recipients = _report$recipients === void 0 ? [] : _report$recipients,
      showGeoInformation = report.showGeoInformation,
      shareViaEmail = report.shareViaEmail,
      uploadAsIdocFormat = report.uploadAsIdocFormat;

  var onReportEnabledChanged = function onReportEnabledChanged(reportEnabled) {
    if (reportEnabled) {
      // if the report has been enabled, add the users email address
      onUpdate({
        report: _objectSpread(_objectSpread({}, report), {}, {
          recipients: [email],
          showGeoInformation: true,
          shareViaEmail: true,
          uploadAsIdocFormat: false
        })
      });
    } else {
      // if the report has been disabled, delete all the emails
      onUpdate({
        report: _objectSpread(_objectSpread({}, report), {}, {
          recipients: [],
          showGeoInformation: true,
          shareViaEmail: true,
          uploadAsIdocFormat: false
        })
      });
    }
  };

  var onShowGeoInformationChanged = function onShowGeoInformationChanged() {
    onUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        showGeoInformation: !showGeoInformation
      })
    });
  };

  var onShareViaEmailChanged = function onShareViaEmailChanged() {
    onUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        shareViaEmail: !shareViaEmail
      })
    });
  };

  var onUploadAsIdocFormatChanged = function onUploadAsIdocFormatChanged() {
    onUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        uploadAsIdocFormat: !uploadAsIdocFormat
      })
    });
  };

  var _useState25 = (0, _react.useState)(''),
      _useState26 = _slicedToArray(_useState25, 2),
      reportRecipient = _useState26[0],
      setReportRecipient = _useState26[1];

  var _useState27 = (0, _react.useState)(false),
      _useState28 = _slicedToArray(_useState27, 2),
      reportRecipientError = _useState28[0],
      setReportRecipientError = _useState28[1];

  var onAddReportRecipientClicked = function onAddReportRecipientClicked() {
    var lowerCaseEmail = reportRecipient.toLowerCase();

    try {
      if (emailSchema.validateSync(lowerCaseEmail)) {
        var updatedReportRecipients = recipients // remove an already existing duplicate
        .filter(function (recipient) {
          return recipient !== lowerCaseEmail;
        }) // add the new object
        .concat(lowerCaseEmail);
        onUpdate({
          report: _objectSpread(_objectSpread({}, report), {}, {
            recipients: updatedReportRecipients
          })
        });
        setReportRecipient('');
        setReportRecipientError(false);
      }
    } catch (e) {
      setReportRecipientError(true);
    }
  };

  var onDeleteEmailClicked = function onDeleteEmailClicked(recipient) {
    var updatedReportRecipients = recipients === null || recipients === void 0 ? void 0 : recipients.filter(function (rec) {
      return rec !== recipient;
    });
    onUpdate({
      report: _objectSpread(_objectSpread({}, report), {}, {
        recipients: updatedReportRecipients
      })
    });
  };

  var onRouteEnabled = function onRouteEnabled(value) {
    if (value) {
      onUpdate({
        route: {
          id: tourRoute === null || tourRoute === void 0 ? void 0 : tourRoute.id,
          allowedDeviation: 500
        }
      });
    } else {
      onUpdate({
        route: null
      });
    }

    setIsRouteEnabled(value);
  };

  var onStartStopAlarms = function onStartStopAlarms(value) {
    onUpdate({
      startStopAlarmsEnabled: value
    });
  };

  var onSelectAlarms = function onSelectAlarms(selectedObjects) {
    onUpdate({
      alarms: selectedObjects.map(function (object) {
        return object.id;
      })
    });
  };

  var onDeselectAlarms = function onDeselectAlarms(deselectedObjects) {
    var alarmsToDeselect = deselectedObjects.map(function (object) {
      return object.id;
    });
    var deselectedAlarms = tour.alarms.filter(function (tourAlarmId) {
      return !alarmsToDeselect.includes(tourAlarmId);
    });
    onUpdate({
      alarms: deselectedAlarms
    });
  };

  var getSelectableAlarms = function getSelectableAlarms() {
    var selectableAlarms = alarms.filter(function (alarm) {
      return !tour.alarms.includes(alarm.id);
    });
    return selectableAlarms.map(function (alarm) {
      return {
        id: alarm.id,
        label: alarm.name
      };
    });
  };

  var getSelectedAlarms = function getSelectedAlarms() {
    return tour.alarms.map(function (tourAlarmId) {
      var selectedAlarm = alarms.find(function (alarm) {
        return alarm.id === tourAlarmId;
      }) || {};
      return {
        id: selectedAlarm.id,
        label: selectedAlarm.name
      };
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-full flex flex-col items-center px-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-192"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.monitor.routeMonitoringEnabled",
      tagName: "span"
    }),
    checked: isRouteEnabled,
    onChange: function onChange(value) {
      return onRouteEnabled(value);
    }
  }), isRouteEnabled ? /*#__PURE__*/_react["default"].createElement(_route["default"], {
    tour: tour,
    tourRoute: tourRoute,
    isMonitoringEnabled: isRouteEnabled,
    onUpdate: onUpdate,
    setTourRoute: setTourRoute
  }) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.road.createTour.monitor.startStopAlarmsEnabled",
      tagName: "span"
    }),
    checked: startStopAlarmsEnabled,
    onChange: onStartStopAlarms
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.monitor.delayedStartEndAlarms",
      tagName: "span"
    }),
    checked: areDelayedAlarmsEnabled,
    onChange: onDelayedStartEndAlarms
  })), areDelayedAlarmsEnabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-96 mb-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.createTour.monitor.delayedStartLimitAlarm",
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline "
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "inline-block fill-blue-500 mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.rail.createTour.monitor.datePicker.startLabel'
    }),
    selectedDate: delayedStartLimitAlarm,
    locale: locale,
    enableTime: true,
    timezone: timezone,
    onChange: onDelayedStartLimitAlarm
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline justify-between"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.createTour.monitor.delayedEndLimitAlarm",
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline "
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "inline-block fill-blue-500 mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DatePicker, {
    inputLabel: intl.formatMessage({
      id: 'widgets.tourBoard.rail.createTour.monitor.datePicker.endLabel'
    }),
    selectedDate: delayedEndLimitAlarm,
    locale: locale,
    enableTime: true,
    timezone: timezone,
    onChange: onDelayedEndLimitAlarm
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mb-2",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.monitorETA",
      tagName: "span"
    }),
    checked: etaAlarmsEnabled,
    onChange: onEtaProviderSelectionChange,
    disabled: endWaypointIndex === -1
  }), etaAlarmsEnabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.earlyArrival",
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "w-20 p-2",
    inputClassName: "text-center",
    "aria-label": "earlyTolerance",
    value: earlyTolerance,
    onChange: onEarlyToleranceChange
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.minutes",
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.lateArrival",
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "w-20 p-2",
    inputClassName: "text-center",
    "aria-label": "lateTolerance",
    value: lateTolerance,
    onChange: onLateToleranceChange
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.minutes",
    tagName: "span"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.alarms"
    }),
    tagName: "span"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDualList.DualListControlled, {
    selectableItems: getSelectableAlarms(),
    selectedItems: getSelectedAlarms(),
    onSelect: onSelectAlarms,
    onSelectAll: onSelectAlarms,
    onDeselect: onDeselectAlarms,
    onDeselectAll: onDeselectAlarms
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4 w-192 flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "my-4",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.selectIndividualNotifications",
      tagName: "span"
    }),
    checked: selectIndividualNotifications,
    onChange: setSelectIndividualNotifications,
    disabled: isSelectIndividualNotificationsToggleDisabled
  }), !selectIndividualNotifications ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-gray-500"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.tourNotificationMessage"
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-500 mb-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.road.createTour.monitor.tourIndividualNotificationMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col my-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, forms.filter(function (map) {
    return map.enabled === true;
  }).map(function (filtered) {
    var name = filtered.name,
        Icon = filtered.Icon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 h-6 w-6",
      title: intl.formatMessage({
        id: "widgets.tourBoard.".concat(name)
      }),
      onClick: function onClick() {
        return onAllEmailAlarmChanged(allEmailAlarmSelected[name], name);
      }
    }, /*#__PURE__*/_react["default"].createElement(IconAnimation, null, Icon));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2 flex"
  }, forms.filter(function (map) {
    return map.enabled === true;
  }).map(function (filtered) {
    var name = filtered.name;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 h-6 w-6 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      checked: mailAlarmSelected[name],
      onChange: function onChange() {
        return setMailAlarmSelected(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, !prev[name]));
        });
      },
      label: name,
      hideLabel: true
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-2 w-72",
    error: mailError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid",
      tagName: "span"
    }),
    place: "top",
    value: mailAddress,
    label: intl.formatMessage({
      id: 'common.email'
    }),
    onChange: function onChange(newValue) {
      setMailError(false);
      setMailAddress(newValue);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'common.ok'
    }),
    onClick: onNewEmailRecipient
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "h-5 w-5 inline-block cursor-pointer"
  })))), /*#__PURE__*/_react["default"].createElement("div", null, emailRecipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-2 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 flex"
    }, forms.filter(function (map) {
      return map.enabled === true;
    }).map(function (filtered) {
      var name = filtered.name;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mr-2 h-6 w-6 flex items-center"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
        checked: recipient[name],
        onChange: function onChange() {
          return onEmailAlarmChanged([recipient], name, !recipient[name]);
        },
        label: name,
        hideLabel: true
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-72 mr-2 truncate"
    }, recipient.recipient), /*#__PURE__*/_react["default"].createElement("span", {
      title: intl.formatMessage({
        id: 'common.delete'
      }),
      onClick: function onClick() {
        return onDeleteEmailRecipient(recipient.recipient);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "h-5 w-5 fill-primary inline-block cursor-pointer"
    }))));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col mt-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, forms.filter(function (map) {
    return map.enabled === true;
  }).map(function (filtered) {
    var name = filtered.name,
        Icon = filtered.Icon;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 h-6 w-6",
      title: intl.formatMessage({
        id: "widgets.tourBoard.".concat(name)
      }),
      onClick: function onClick() {
        return onAllPhoneAlarmChanged(allPhoneAlarmSelected[name], name);
      }
    }, /*#__PURE__*/_react["default"].createElement(IconAnimation, null, Icon));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mr-2"
  }, forms.filter(function (map) {
    return map.enabled === true;
  }).map(function (filtered) {
    var name = filtered.name;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 h-6 w-6 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      checked: phoneAlarmSelected[name],
      onChange: function onChange() {
        return setPhoneAlarmSelected(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, !prev[name]));
        });
      },
      label: name,
      hideLabel: true
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-baseline"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-2 w-72",
    error: phoneError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.smsIsNotValid",
      tagName: "span"
    }),
    place: "top",
    value: phoneNumber,
    label: intl.formatMessage({
      id: 'common.sms'
    }),
    onChange: function onChange(newValue) {
      setPhoneError(false);
      onPhoneNumberChanged(newValue);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'common.ok'
    }),
    onClick: onNewPhoneRecipient
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "h-5 w-5 inline-block cursor-pointer"
  })))), /*#__PURE__*/_react["default"].createElement("div", null, smsRecipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-2 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mr-2 flex"
    }, forms.filter(function (map) {
      return map.enabled === true;
    }).map(function (filtered) {
      var name = filtered.name;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mr-2 h-6 w-6 flex items-center"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
        checked: recipient[name],
        onChange: function onChange() {
          return onPhoneAlarmChanged([recipient], name, !recipient[name]);
        },
        label: name,
        hideLabel: true
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-72 mr-2 truncate"
    }, recipient.recipient), /*#__PURE__*/_react["default"].createElement("span", {
      title: intl.formatMessage({
        id: 'common.delete'
      }),
      onClick: function onClick() {
        return onDeletePhoneRecipient(recipient.recipient);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "h-5 w-5 fill-primary inline-block cursor-pointer"
    }))));
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-192"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "my-4",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.enableReport",
      tagName: "span"
    }),
    checked: !shareViaEmail || recipients.length > 0,
    onChange: onReportEnabledChanged
  }), !shareViaEmail || recipients.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourReportMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourReportPositionMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withoutPositionInformation"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: showGeoInformation,
    onChange: onShowGeoInformationChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withPositionInformation"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.uploadReport"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: shareViaEmail,
    onChange: onShareViaEmailChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.emailReport"
  }))), !shareViaEmail ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-2 ml-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.Idoc"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: uploadAsIdocFormat,
    onChange: onUploadAsIdocFormatChanged
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-2 w-72",
    value: reportRecipient,
    label: intl.formatMessage({
      id: 'common.email'
    }),
    error: reportRecipientError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid"
    }),
    onChange: function onChange(newValue) {
      setReportRecipientError(false);
      setReportRecipient(newValue);
    }
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "cursor-pointer h-5 w-5",
    onClick: onAddReportRecipientClicked
  })), recipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center mb-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-72 mr-2 truncate"
    }, recipient), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "fill-primary cursor-pointer h-5 w-5",
      onClick: function onClick() {
        return onDeleteEmailClicked(recipient);
      }
    }));
  })) : null));
};

exports.Monitoring = Monitoring;

var noop = function noop() {};

Monitoring.propTypes = {
  tour: _propTypes["default"].shape({
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].number),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    delayedStartLimitAlarm: _propTypes["default"].string,
    delayedEndLimitAlarm: _propTypes["default"].string,
    etaProvider: _propTypes["default"].string,
    etaAlarmsEnabled: _propTypes["default"].bool,
    startStopAlarmsEnabled: _propTypes["default"].bool,
    report: _propTypes["default"].shape({
      recipients: _propTypes["default"].arrayOf(_propTypes["default"].string),
      showGeoInformation: _propTypes["default"].bool,
      shareViaEmail: _propTypes["default"].bool,
      uploadAsIdocFormat: _propTypes["default"].bool
    }),
    route: _propTypes["default"].shape({
      id: _propTypes["default"].string
    }),
    emailRecipients: _propTypes["default"].arrayOf(),
    smsRecipients: _propTypes["default"].arrayOf()
  }).isRequired,
  tourRoute: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    properties: _propTypes["default"].shape({
      time: _propTypes["default"].number,
      distance: _propTypes["default"].number
    }),
    geometry: _propTypes["default"].shape({
      coordinates: _propTypes["default"].arrayOf(_propTypes["default"].number)
    })
  }),
  onUpdate: _propTypes["default"].func,
  setTourRoute: _propTypes["default"].func,
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired
};
Monitoring.defaultProps = {
  tourRoute: {},
  onUpdate: noop,
  setTourRoute: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.road'])(Monitoring);

exports["default"] = _default;